<template>
  <router-view />
  <LoginDialog ref="loginDialogRef" />
</template>

<script>
import { ref, onMounted } from 'vue'
import { useStore } from 'vuex'
import LoginDialog from '@/components/LoginDialog.vue'

export default {
  name: 'App',
  components: {
    LoginDialog
  },
  setup() {
    const store = useStore()
    const loginDialogRef = ref(null)

    onMounted(async () => {
      if (store.state.user.isLogin) {
        try {
          await store.dispatch('user/getUserInfo')
        } catch (error) {
          console.error('获取用户信息失败', error)
        }
      }
    })

    const showLogin = () => {
      loginDialogRef.value?.show()
    }

    window.showLogin = showLogin

    return {
      loginDialogRef
    }
  }
}
</script>
